import { NJSelect } from '@engie-group/fluid-design-system-react';
import { UM } from '../_components/tokens';
import { BUILDING_COLOR_MODES, BUILDING_LEGENDS } from './mocks';
import type { BuildingColorMode } from './types';

/**
 * Couche "Bâtiments" — toujours épinglée en haut du panneau, quelle que soit la
 * proposition affichée. C'est la couche la plus stratégique (conso), donc elle
 * reste visible en permanence plutôt que noyée dans une catégorie parmi d'autres.
 */
export function BuildingLayerCard({
  mode,
  onModeChange,
}: {
  mode: BuildingColorMode;
  onModeChange: (mode: BuildingColorMode) => void;
}) {
  const legend = BUILDING_LEGENDS[mode];

  return (
    <div style={{ padding: '12px 16px', borderBottom: `1px solid ${UM.border}`, background: UM.accentLight }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <span style={{ fontWeight: 600, fontSize: 13, color: UM.text }}>🏢 Bâtiments</span>
        <span style={{ fontSize: 11, color: UM.accent, fontWeight: 600 }}>Toujours affiché</span>
      </div>

      <NJSelect.Root
        id="building-color-mode"
        label="Mode de colorisation"
        listNavigationLabel="Utiliser les flèches et Entrée pour sélectionner"
        buttonDefaultValueLabel="Choisir un mode"
        initialValue={mode}
        onChange={(v) => onModeChange(v as BuildingColorMode)}
      >
        {BUILDING_COLOR_MODES.map((m) => (
          <NJSelect.Item key={m.id} value={m.id}>{m.label}</NJSelect.Item>
        ))}
      </NJSelect.Root>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 8 }}>
        {legend.map((step) => (
          <div key={step.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 12, height: 12, background: step.color, flexShrink: 0 }} />
            <span style={{ fontSize: 12, color: UM.textMuted }}>{step.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
